import React, { Component } from "react";
import { TextInput, View } from "react-native";
import PropTypes from "prop-types";

import colors from "@constants/color";
import Metrics, { fonts } from "@constants/metrics";
import Text from "@components/AppText";

export default function InputBox(props) {
  const [focus, setFocus] = React.useState(false);

  const {
    tId = "",
    placeholder = "",
    password = false,
    lines = 1,
    multiline = false,
    maxLength = 50,
    error = false,
    errorMessage = "",
    keyboardType = "default",
    labelText = "",
    textBoxHeight = 56,
    icon = null,
    required = false,
    onChange = (e) => e,
    value = "",
    editable = true,
    onKeyPress = () => {},
    onSubmitEditing = () => {},
    setRef = () => {},
    labelTextColor = "#000",
    labelTextStyle = {},
    containerStyle = {},
    inputStyle = {},
    borderRadius = 4,
    bold = false,
    hideError = true,
    autoFocus = false,
    borderOnFocus = "#000",
    fontType = "head3",
    helperText = "",
    helperTextColor = "rgba(0,0,0,0.36)",
    onBlur = () => {},
    returnKeyType = "send",
  } = props;

  return (
    <View style={[containerStyle, { position: "relative" }]}>
      {placeholder !== "" && value !== "" ? (
        <View
          style={{
            marginLeft: 4,
            flexDirection: "row",
            backgroundColor: "white",
            position: "absolute",
            zIndex: 3,
            top: 5,
            left: 10,
            // paddingLeft: 3,
          }}
        >
          <Text
            style={[
              {
                fontFamily: "NotoSansDevanagari-Regular",
                color: "rgba(0,0,0,0.56)",
                fontSize: 12,
                lineHeight: 16,
              },
              labelTextStyle,
            ]}
          >
            {placeholder}{" "}
          </Text>
          {required && (
            <Text
              style={{ color: "#E40046", position: "relative", top: -5 }}
              fontType="head3"
            >
              *
            </Text>
          )}
        </View>
      ) : null}
      <View style={{ justifyContent: "center" }}>
        <TextInput
          testID={tId}
          style={[
            {
              borderBottomWidth: 1,
              backgroundColor: colors.white,
              borderColor: focus
                ? borderOnFocus
                : error
                  ? colors.errorRed
                  : "rgba(0, 0, 0, 0.2)",
              height: !lines ? textBoxHeight : null,
              fontSize: 14,
              lineHeight: 28,
              fontFamily: "NotoSansDevanagari-SemiBold",
              paddingLeft: 15,
              paddingTop: 15,
              paddingBottom: 0,
              // paddingTop:5,
              // paddingVertical: 0,
              // padding: 0,
              // paddingBottom: 0,
              borderRadius: borderRadius,
              textAlignVertical: "top",
              color: colors.black,
              opacity: 0.8,
              width: "100%",
              justifyContent: "center",
              textAlignVertical: "top",
              // backgroundColor: "yellow",
            },
            inputStyle,
          ]}
          autoFocus={autoFocus}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={() => {
            setFocus(false);
            onBlur();
          }}
          placeholder={placeholder}
          onChangeText={(text) => onChange(text)}
          value={value}
          secureTextEntry={password}
          numberOfLines={lines}
          multiline={multiline}
          maxLength={maxLength}
          error={error}
          keyboardType={keyboardType}
          returnKeyType={returnKeyType}
          editable={editable}
          selectionColor={colors.primary}
          //^passable values^ = number-pad, decimal-pad, numeric, email-address, phone-pad
          onKeyPress={onKeyPress}
          onSubmitEditing={onSubmitEditing}
          ref={setRef}
        />
        {Boolean(helperText) && (
          <Text
            style={{
              color: helperTextColor,
              paddingLeft: 12,
              fontSize: 12,
            }}
          >
            {helperText}
          </Text>
        )}
        {hideError && (
          <View style={{ paddingLeft: 15 }}>
            {errorMessage !== "" && (
              <Text
                style={{
                  color: colors.errorRed,
                  marginTop: 4,
                  opacity: error ? 1 : 0,
                }}
                fontType="content2"
              >
                {errorMessage}
              </Text>
            )}
          </View>
        )}
      </View>
    </View>
  );
}

InputBox.propTypes = {
  placeholder: PropTypes.string,
  password: PropTypes.string,
  lines: PropTypes.number,
  multiline: PropTypes.bool,
  maxLength: PropTypes.number,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  keyboardType: PropTypes.string,
  labelText: PropTypes.string,
  textBoxHeight: PropTypes.number,
  icon: PropTypes.node,
  onChange: PropTypes.func,
};
